import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <footer className="footer">
      <Box sx={{ my: 8, textAlign: "center" }}>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Box>
            <svg
              width="35"
              height="35"
              viewBox="0 0 21 21"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <title>equal-housing@2x</title>
              <desc>Created with Sketch.</desc>
              <g
                id="equal-housingv-0-3-0-0-6-0-1-1-0-0-0"
                stroke="none"
                strokeWidth="1"
                fillRule="evenodd"
              >
                <g
                  id="Equal-logosv-0-3-0-0-6-0-1-1-0-0-0"
                  transform="translate(1.000000, 3.000000)"
                >
                  <g id="Group-4v-0-3-0-0-6-0-1-1-0-0-0">
                    <polygon
                      id="Fill-1v-0-3-0-0-6-0-1-1-0-0-0"
                      points="5.35243799 10.2807205 12.2145754 10.2807205 12.2145754 8.61160598 5.35243799 8.61160598"
                    ></polygon>
                    <polygon
                      id="Fill-2v-0-3-0-0-6-0-1-1-0-0-0"
                      points="5.35243799 7.30410013 12.2145754 7.30410013 12.2145754 5.63498565 5.35243799 5.63498565"
                    ></polygon>
                    <path
                      d="M8.78348723,-1.97061922e-05 L2.91654206e-05,4.35307815 L2.91654206e-05,6.21107647 L0.860117419,5.78483154 L0.860117419,11.8663595 L0.860117419,13.5355725 L2.5069915,13.5355725 L15.0600802,13.5355725 L16.7070515,13.5355725 L16.7070515,11.8663595 L16.7070515,5.78483154 L17.5670425,6.21107647 L17.5670425,4.35307815 L8.78348723,-1.97061922e-05 Z M2.5069915,4.96889665 L8.78348723,1.85866834 L15.0600802,4.96879812 L15.0600802,11.8663595 L2.5069915,11.8663595 L2.5069915,4.96889665 Z"
                      id="Fill-3v-0-3-0-0-6-0-1-1-0-0-0"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </Box>
          <Typography sx={{ fontSize: 10 }}>
            This community complies with the federal housing act and does not
            discriminate on the basis of race, color, religion, national origin,
            sex, familial status, disability or on any other basis protected by
            applicable state, federal or local fair housing laws.
          </Typography>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
